import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, FuseLoadingBarComponent],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(private authService: AuthService) {
        this.authService.restoreSession();
    }
}
